import { faPaperPlaneTop, faRefresh } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@hl/ui-components';

import {
  MessageInputBoxButtons,
  MessageInputBoxTextAreaWrapper,
  MessageInputBoxWrapper,
} from './MessageInputBoxWrapper.styled';
import { useMessageInput } from './utils/useMessageInput';
import { useResetChat } from './utils/useResetChat';

export interface MessageInputBoxProps {
  minHeight?: string;
  className?: string;
  placeholder?: string;
  backgroundColor?: string;
  noBorder?: boolean;
}

export const MessageInputBox = ({ 
  minHeight = '8rem', 
  className = 'message-input-box', 
  placeholder = 'Ask me anything...',
  backgroundColor,
  noBorder
}: MessageInputBoxProps = {}) => {
  const { message, sendMessage, inputRefCB } = useMessageInput();
  const { resetChatSession, error } = useResetChat();

  return (
    <MessageInputBoxWrapper data-testid="messageBox" $resetError={!!error} $background={backgroundColor} $noBorder={noBorder} className={className}>
      <MessageInputBoxTextAreaWrapper $minHeight={minHeight}>
        <textarea placeholder={placeholder} ref={inputRefCB} />
      </MessageInputBoxTextAreaWrapper>
      <MessageInputBoxButtons>
        <Icon
          className="message-input-btn reset"
          onClick={() => {
            resetChatSession();
          }}
          icon={faRefresh}
          title="Clears chat history to start a new topic"
        ></Icon>
        <Icon
          icon={faPaperPlaneTop}
          onClick={sendMessage}
          className="message-input-btn"
          title="Send Message"
          disabled={!message}
        />
      </MessageInputBoxButtons>
    </MessageInputBoxWrapper>
  );
};
